import type { SanctionsList, SanctionsStatus } from '../dataProvider/types';

/** Display vocabulary for the sanctions-screening surface (D-sanctions, Phase 7 surface 3). */

export const SANCTIONS_LIST_LABEL: Record<SanctionsList, string> = {
  ofac: 'OFAC (US)',
  uk_hmt: 'UK HMT',
  pep: 'PEP',
};

export const SANCTIONS_STATUS_LABEL: Record<SanctionsStatus, string> = {
  pending_review: 'Pending review',
  cleared: 'Cleared (false positive)',
  confirmed: 'Confirmed match',
};

export const SANCTIONS_STATUS_COLOR: Record<
  SanctionsStatus,
  'warning' | 'success' | 'error'
> = {
  pending_review: 'warning',
  cleared: 'success',
  confirmed: 'error',
};
